import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  estimatedProductPriceAtom,
  sourceAtom,
  uploadFileAtom,
  wordCountAtom,
  workloadAtom,
  worksAtom,
} from "src/recoil/atoms/textTranslation";
import { workloadUnitType } from "utils/textTranslation";

// 새로운 단가표 구조 - 분야별로 구분
const priceTable = {
  // 소설
  NOVEL: {
    "한국어->영어": { unit: "word", price: 63 },
    "한국어->일본어": { unit: "word", price: 63 },
    "한국어->중국어(간체)": { unit: "word", price: 63 },
    "한국어->스페인어": { unit: "word", price: 79 },
    "한국어->베트남어": { unit: "word", price: 79 },
    "한국어->인도네시아어": { unit: "word", price: 79 },
    "한국어->태국어": { unit: "word", price: 79 },
    "영어->한국어": { unit: "word", price: 32 },
    "일본어->한국어": { unit: "letter", price: 12 },
    "중국어->한국어": { unit: "letter", price: 12 },
  },
  // 대본
  SCREENPLAY: {
    "한국어->영어": { unit: "word", price: 63 },
    "한국어->일본어": { unit: "word", price: 63 },
    "한국어->중국어(간체)": { unit: "word", price: 63 },
    "한국어->스페인어": { unit: "word", price: 79 },
    "한국어->베트남어": { unit: "word", price: 79 },
    "한국어->인도네시아어": { unit: "word", price: 79 },
    "한국어->태국어": { unit: "word", price: 79 },
    "영어->한국어": { unit: "word", price: 32 },
    "일본어->한국어": { unit: "letter", price: 12 },
    "중국어->한국어": { unit: "letter", price: 12 },
  },
  // 시놉시스
  SYNOPSIS: {
    "한국어->영어": { unit: "word", price: 63 },
    "한국어->일본어": { unit: "word", price: 63 },
    "한국어->중국어(간체)": { unit: "word", price: 63 },
    "한국어->스페인어": { unit: "word", price: 79 },
    "한국어->베트남어": { unit: "word", price: 79 },
    "한국어->인도네시아어": { unit: "word", price: 79 },
    "한국어->태국어": { unit: "word", price: 79 },
    "영어->한국어": { unit: "word", price: 32 },
    "일본어->한국어": { unit: "letter", price: 12 },
    "중국어->한국어": { unit: "letter", price: 12 },
  },
  // 소개서
  INTRODUCTION: {
    "한국어->영어": { unit: "word", price: 63 },
    "한국어->일본어": { unit: "word", price: 63 },
    "한국어->중국어(간체)": { unit: "word", price: 63 },
    "한국어->스페인어": { unit: "word", price: 79 },
    "한국어->베트남어": { unit: "word", price: 79 },
    "한국어->인도네시아어": { unit: "word", price: 79 },
    "한국어->태국어": { unit: "word", price: 79 },
    "영어->한국어": { unit: "word", price: 32 },
    "일본어->한국어": { unit: "letter", price: 12 },
    "중국어->한국어": { unit: "letter", price: 12 },
  },
  // 강의자료
  LECTURE: {
    "한국어->영어": { unit: "word", price: 63 },
    "한국어->일본어": { unit: "word", price: 63 },
    "한국어->중국어(간체)": { unit: "word", price: 63 },
    "한국어->스페인어": { unit: "word", price: 79 },
    "한국어->베트남어": { unit: "word", price: 79 },
    "한국어->인도네시아어": { unit: "word", price: 79 },
    "한국어->태국어": { unit: "word", price: 79 },
    "영어->한국어": { unit: "word", price: 32 },
    "일본어->한국어": { unit: "letter", price: 12 },
    "중국어->한국어": { unit: "letter", price: 12 },
  },
  // 논문
  THESIS: {
    "한국어->영어": { unit: "word", price: 95 },
    "한국어->일본어": { unit: "word", price: 95 },
    "한국어->중국어(간체)": { unit: "word", price: 95 },
    "한국어->스페인어": { unit: "word", price: 118 },
    "한국어->베트남어": { unit: "word", price: 118 },
    "한국어->인도네시아어": { unit: "word", price: 118 },
    "한국어->태국어": { unit: "word", price: 118 },
    "영어->한국어": { unit: "word", price: 32 },
    "일본어->한국어": { unit: "letter", price: 12 },
    "중국어->한국어": { unit: "letter", price: 12 },
  },
  // 계약서
  CONTRACT: {
    "한국어->영어": { unit: "word", price: 63 },
    "한국어->일본어": { unit: "word", price: 63 },
    "한국어->중국어(간체)": { unit: "word", price: 63 },
    "한국어->스페인어": { unit: "word", price: 79 },
    "한국어->베트남어": { unit: "word", price: 79 },
    "한국어->인도네시아어": { unit: "word", price: 79 },
    "한국어->태국어": { unit: "word", price: 79 },
    "영어->한국어": { unit: "word", price: 32 },
    "일본어->한국어": { unit: "letter", price: 12 },
    "중국어->한국어": { unit: "letter", price: 12 },
  },
  // 기타
  OTHER: {
    "한국어->영어": { unit: "word", price: 63 },
    "한국어->일본어": { unit: "word", price: 63 },
    "한국어->중국어(간체)": { unit: "word", price: 63 },
    "한국어->스페인어": { unit: "word", price: 79 },
    "한국어->베트남어": { unit: "word", price: 79 },
    "한국어->인도네시아어": { unit: "word", price: 79 },
    "한국어->태국어": { unit: "word", price: 79 },
    "영어->한국어": { unit: "word", price: 32 },
    "일본어->한국어": { unit: "letter", price: 12 },
    "중국어->한국어": { unit: "letter", price: 12 },
  },
};

/**
 * 언어 쌍에 따라 사용할 단위를 결정하는 함수
 * @param sourceLanguage 출발 언어
 * @param targetLanguage 도착 언어
 * @returns "word" 또는 "letter"
 */
const getUnitByLanguagePair = (sourceLanguage: string, targetLanguage: string): "word" | "letter" => {
  const languagePair = `${sourceLanguage}->${targetLanguage}`;
  
  // 일본어나 중국어가 출발어인 경우 letter 사용
  if (sourceLanguage === "일본어" || sourceLanguage === "중국어") {
    return "letter";
  }
  
  // 그 외의 경우는 word 사용 (영어, 한국어 출발)
  return "word";
};

const useEstimatePriceCalculator = () => {
  const { type } = useRecoilValue(sourceAtom);
  const { sourceLanguage, targetLanguages } = useRecoilValue<{
    sourceLanguage: String;
    targetLanguages: String[];
  }>(worksAtom);

  const setEstimatedProductPrice = useSetRecoilState(estimatedProductPriceAtom);
  const setWorkload = useSetRecoilState(workloadAtom);
  const { wordCount, letterCount } = useRecoilValue(wordCountAtom);
  const uploadFile = useRecoilValue(uploadFileAtom);

  const calculatedEstimatedProductPrice = () => {
    let savedPrice = 0;

    if (type === "" || sourceLanguage === "" || uploadFile.size === 0) return;
    if (wordCount === null && letterCount === null) return;
    if (targetLanguages.length === 0) {
      setEstimatedProductPrice(0);
      return;
    }

    try {
      // 사용할 단위 결정 (출발어 기준)
      const unitType = getUnitByLanguagePair(sourceLanguage as string, "");
      const countToUse = unitType === "letter" ? letterCount : wordCount;

      for (const targetLanguage of targetLanguages) {
        const languagePair = `${sourceLanguage}->${targetLanguage}`;
        
        // 해당 분야의 단가표에서 언어 쌍 정보 조회
        const priceInfo = priceTable[type as keyof typeof priceTable]?.[languagePair as keyof typeof priceTable[keyof typeof priceTable]];
        
        if (priceInfo) {
          // 단가표에 정의된 단위에 따라 계산
          const countForCalculation = priceInfo.unit === "letter" ? letterCount : wordCount;
          savedPrice += priceInfo.price * countForCalculation;
        }
      }

      setEstimatedProductPrice(savedPrice === 0 ? null : savedPrice);
      setWorkload({
        amount: countToUse,
        unit: unitType === "letter" 
          ? { id: workloadUnitType.LETTER }
          : { id: workloadUnitType.WORD },
      });
    } catch (e) {
      console.log("단가 계산 중 오류 발생:", e);
    }
  };

  return { calculatedEstimatedProductPrice };
};

export default useEstimatePriceCalculator;